
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/leaderboards/unit/[[...slug]]",
      function () {
        return require("private-next-pages/leaderboards/unit/[[...slug]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/leaderboards/unit/[[...slug]]"])
      });
    }
  